import {
    collection,
    query,
    where,
    orderBy,
    limit,
    doc,
    onSnapshot,
    type Firestore
} from "firebase/firestore";
import type {
    ActivityFirestore,
    FirestoreDocSnapshot
} from "@scripts/react/components/Activities/ActivitiesContext";

/**
 * ActivityFirestore adapter backed by the v9 modular Firestore SDK.
 */
export function createRapidFirestore(firestoreDb: Firestore): ActivityFirestore {
    return {
        onCollectionSnapshot(path, constraints, onNext, onError) {
            const ref = collection(firestoreDb, path);
            const queryConstraints = [];
            for (const [field, op, value] of constraints.where ?? []) {
                queryConstraints.push(where(field, op as any, value));
            }
            if (constraints.orderBy) {
                queryConstraints.push(orderBy(constraints.orderBy[0], constraints.orderBy[1]));
            }
            if (constraints.limit) {
                queryConstraints.push(limit(constraints.limit));
            }
            return onSnapshot(
                query(ref, ...queryConstraints),
                (snapshot) => {
                    const docs: FirestoreDocSnapshot[] = snapshot.docs.map((d) => ({
                        id: d.id,
                        exists: d.exists(),
                        data: () => d.data()
                    }));
                    onNext(docs);
                },
                onError
            );
        },
        onDocSnapshot(path, docId, onNext, onError) {
            return onSnapshot(
                doc(firestoreDb, path, docId),
                (d) => onNext({ id: d.id, exists: d.exists(), data: () => d.data() }),
                onError
            );
        }
    };
}
